import { useRouter } from "next/router"
import { KeyboardEvent, useEffect, useMemo, useReducer, useState } from "react"
import SearchIcon from '@mui/icons-material/Search';
import Grid from "@mui/material/Grid";
import { TextFieldProps } from "@mui/material/TextField";
import dynamic from "next/dynamic";
import { useLayoutData } from "../../../../utils/contexts/LayoutContext";
import { FindButtonProps } from "../FindDesignTypes";
import { filterUrl } from "../Find";
import { PageType } from "../../../../pages/_app";
import { FilterFindQueryProps } from "../Find.types";
import { useTranslation } from "react-i18next";

const FilterFindQuery = ({
  filters,
  colors,
  mmbr,
  pageUrl,
  isMobile
}: FilterFindQueryProps) => {
  const router = useRouter()
  const { partnerSiteFull, templatePath } = useLayoutData()
  const [searchQuery, setSearchQuery] = useState<string>('')
  const [searchTimeout, setSearchTimeout] = useState<NodeJS.Timeout | undefined>()
  const [, forceUpdate] = useReducer(x => x + 1, 0)
  const { t } = useTranslation();

  const path = templatePath === PageType.RBhuPP ? `${templatePath}/templates/${partnerSiteFull?.content?.templateId ?? 'AutoraTemplate'}` : templatePath

  const FindInput = useMemo(() => dynamic<TextFieldProps>(() => import(`../../../../design/${path}/_findDesign/Design`).then((style) => style.FindInput)), [path])
  const FindButton = useMemo(() => dynamic<FindButtonProps>(() => import(`../../../../design/${path}/_findDesign/Design`).then((style) => style.FindButton)), [path])

  const handleSearchOnKeyUp = () => {
    clearTimeout(searchTimeout)

    const timeout = setTimeout(() => {
      handleSearch()
    }, 2000)

    setSearchTimeout(timeout)
  }

  const handleSearch = (e?: KeyboardEvent<HTMLDivElement>) => {
    if (e !== undefined && e.type === "keydown" && e.key !== "Enter") return

    const url = filters?.targetUrl?.replace('{value}', searchQuery ?? '') as string
    router.push(filterUrl(filters, undefined, url, pageUrl, mmbr))
  }

  useEffect(() => {
    setSearchQuery(filters?.defaultValues ? filters?.defaultValues[0] : '')
    forceUpdate()
  }, [filters?.defaultValues])

  return (
    <>
      <Grid container
        display={"flex"}
        flexDirection={"row"}
        flexWrap={"nowrap"}
        justifyContent={isMobile ? 'center' : undefined}
        my={isMobile ? 2 : undefined}
        columnSpacing={!isMobile ? 1 : undefined}
      >
        <Grid item xs={isMobile ? 10 : true}>
          <FindInput
            type="text"
            placeholder={t("web.listing.filter.find.inputPlaceholder")}
            value={searchQuery}
            onChange={(e) => setSearchQuery(e.target.value)}
            onKeyDown={handleSearch}
            onKeyUp={isMobile ? handleSearchOnKeyUp : undefined}
            fullWidth
            autoComplete="off"
          />
        </Grid>
        {!isMobile ? (
          <Grid item>
            <FindButton
              bgcolor={colors.mainColor}
              bghovercolor={colors.secondaryColor}
              onClick={() => handleSearch()}
              variant="contained"
              inputbutton={1}
              aria-label="Keresés"
            >
              <SearchIcon fontSize="large" />
            </FindButton>
          </Grid>
        ) : null}
      </Grid>
    </>
  )
}

export default FilterFindQuery